import commandEngine from './CommandEngine.js';
import jxWindowManager from '../../../../../JxControls/JxWindowManager/JxWindowManager.jsx';

/**
 * Registers the /stopwatch command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /stopwatch <description> — opens a stopwatch, description is free text (joined params)
 */
export function registerStopwatchCommand() {
    commandEngine.register('/stopwatch', {
        hint: 'Open stopwatch',
        params: [{ name: 'description', hint: '<description>' }],
        handler: (params) => {
            const description = params.join(' ');
            jxWindowManager.openWindow('JxStopwatchForm', 'global', { description, autoStart: true }, true);
        },
    });
}
